import { CSSProperties, ReactNode } from 'react';
import { Box, ButtonBase } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';
import { TextColor } from '@setvi/shared/enums';

interface DrawerHeaderProps {
  title: string;
  color?: CSSProperties['color'];
  titleIcon?: ReactNode;
  closeIcon?: ReactNode;
  disabled?: boolean;
  handleClose: () => void;
}

export const DrawerHeaderTitle = ({
  title,
  color = TextColor.Black,
  disabled,
  closeIcon,
  titleIcon,
  handleClose
}: DrawerHeaderProps) => {
  const titleElement = (
    <SText size="lg" weight="semibold" title={title} fontColor={color} />
  );

  return (
    <Box display="flex" alignItems="center" gridGap="4px">
      <ButtonBase
        disabled={disabled}
        onClick={handleClose}
        style={{ padding: 4, borderRadius: '50%' }}>
        {closeIcon || <CloseIcon style={{ fontSize: 14, fill: color }} />}
      </ButtonBase>
      {titleIcon ? (
        <Box display="flex" alignItems="center" gridGap="4px">
          {titleIcon}
          {titleElement}
        </Box>
      ) : (
        titleElement
      )}
    </Box>
  );
};
